import {
  PSMS_RECOVERY_RATES_TREND_REQUEST,
  PSMS_RECOVERY_RATES_TREND_SUCCESS,
  PSMS_RECOVERY_RATES_TREND_FAILURE,
  PSMS_RECOVERY_RATES_TREND_LOADING,
  PSMS_SETTLEMENTS_DETAILS_REQUEST,
  PSMS_SETTLEMENTS_DETAILS_SUCCESS,
  PSMS_SETTLEMENTS_DETAILS_FAILURE,
  PSMS_SETTLEMENTS_DETAILS_LOADING,
  PSMS_AR_SUMMARY_REQUEST,
  PSMS_AR_SUMMARY_SUCCESS,
  PSMS_AR_SUMMARY_FAILURE,
  PSMS_AR_SUMMARY_LOADING
} from '../actionTypes';

/**
 * Action creator to request recovery rates trend metrics data
 * @param payload - The request payload containing filters (TimeFilter, TimeFilterText, Region, State, Market, etc.)
 */
export const getRecoveryRatesTrendRequest = (payload: any) => ({
  type: PSMS_RECOVERY_RATES_TREND_REQUEST,
  payload
});

/**
 * Action creator to set loading state
 * @param payload - Boolean indicating if data is loading
 */
export const getRecoveryRatesTrendLoading = (payload: boolean) => ({
  type: PSMS_RECOVERY_RATES_TREND_LOADING,
  payload
});

/**
 * Action creator for successful API response
 * @param payload - The API response data
 */
export const getRecoveryRatesTrendSuccess = (payload: any) => ({
  type: PSMS_RECOVERY_RATES_TREND_SUCCESS,
  payload
});

/**
 * Action creator for API failure
 * @param payload - Error information
 */
export const getRecoveryRatesTrendFailure = (payload: any) => ({
  type: PSMS_RECOVERY_RATES_TREND_FAILURE,
  payload
});

/**
 * Action creator to request settlements details data (calls 3 APIs in parallel)
 * @param payload - The request payload containing filters (TimeFilter, TimeFilterText, Region, State, Market, etc.)
 */
export const getSettlementsDetailsRequest = (payload: any) => ({
  type: PSMS_SETTLEMENTS_DETAILS_REQUEST,
  payload
});

/**
 * Action creator to set loading state
 * @param payload - Boolean indicating if data is loading
 */
export const getSettlementsDetailsLoading = (payload: boolean) => ({
  type: PSMS_SETTLEMENTS_DETAILS_LOADING,
  payload
});

/**
 * Action creator for successful API response
 * @param payload - The API response data containing total, open, and closed settlements
 */
export const getSettlementsDetailsSuccess = (payload: any) => ({
  type: PSMS_SETTLEMENTS_DETAILS_SUCCESS,
  payload
});

/**
 * Action creator for API failure
 * @param payload - Error information
 */
export const getSettlementsDetailsFailure = (payload: any) => ({
  type: PSMS_SETTLEMENTS_DETAILS_FAILURE,
  payload
});

export const getARSummaryRequest = (payload: any) => ({
  type: PSMS_AR_SUMMARY_REQUEST,
  payload
});

export const getARSummaryLoading = (payload: boolean) => ({
  type: PSMS_AR_SUMMARY_LOADING,
  payload
});

export const getARSummarySuccess = (payload: any) => ({
  type: PSMS_AR_SUMMARY_SUCCESS,
  payload
});

export const getARSummaryFailure = (payload: any) => ({
  type: PSMS_AR_SUMMARY_FAILURE,
  payload
});
